export const movementDirection = item => item.direction || (
  ['SORTIE', 'PERTE', 'PROMOTION'].includes(item.typeMouvement) ? 'SORTIE'
    : ['ENTREE', 'RETOUR_CLIENT'].includes(item.typeMouvement) ? 'ENTREE' : null
);

const normalizeUnit = value => {
  const unit = String(value || '').trim();
  const key = unit.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  return /^(unit|unite)(s|\(s\))?$/.test(key) ? 'unité(s)' : unit;
};

export function createMovementUnitResolver(movements, stocks = []) {
  const unitsByArticle = new Map();
  for (const row of [...movements, ...stocks]) {
    const unit = normalizeUnit(row.unite);
    if (!unit || row.articleId == null) continue;
    const key = String(row.articleId);
    if (!unitsByArticle.has(key)) unitsByArticle.set(key, new Set());
    unitsByArticle.get(key).add(unit);
  }
  return row => {
    const explicit = normalizeUnit(row.unite);
    if (explicit) return explicit;
    const known = row.articleId == null ? null : unitsByArticle.get(String(row.articleId));
    return known?.size === 1 ? [...known][0] : 'Unité non renseignée';
  };
}

export function sumStockMovements(movements, unitOf) {
  const incoming = {}, outgoing = {};
  for (const item of movements) {
    const direction = movementDirection(item);
    const target = direction === 'ENTREE' ? incoming : direction === 'SORTIE' ? outgoing : null;
    const unit = unitOf(item);
    if (target) target[unit] = (target[unit] || 0) + (Number(item.quantite) || 0);
  }
  return { incoming, outgoing };
}
